import { LoadingOverlay } from '@eventbrite/eds-loading-overlay';
import loadable from '@loadable/component';
import React from 'react';
import { getLoadingOverlayStyle } from '../utils/rebrand';
import animationData from './logoMarkToCheckboxObject';

//TODO: Investigate Methods to Load Animations Without Exceeding Bundle Size (EB-271301)

const LottieComponent = loadable(
    () => import(/* webpackChunkName: 'LottieModule' */ 'lottie-react'),
    {
        fallback: (
            <LoadingOverlay
                isShown={true}
                style={getLoadingOverlayStyle(true)}
            />
        ),
    },
);

const LogoMarkToCheckbox = ({
    endFrame,
    loop = true,
    onComplete,
    size = '200px',
}: {
    endFrame?: number;
    loop?: boolean;
    onComplete?: () => void;
    size?: string;
    isAppRebrandActive?: boolean;
}) => {
    return (
        <LottieComponent
            animationData={animationData}
            loop={loop}
            initialSegment={endFrame ? [0, endFrame] : undefined}
            onComplete={onComplete}
            style={{ width: size, height: size }}
        />
    );
};

export default LogoMarkToCheckbox;
